import { useState } from 'react'
import { Element } from '../../../../common/html/element'

export const ItemHover = ({ children, style, ...props }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#C8E3FF')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor, ...style }}
      className="cursorPointer"
      {...props}
    >
      {children}
    </Element>
  )
}
